// extracted by mini-css-extract-plugin
export default {"label":"File_label__nV1T0","tooltip":"File_tooltip__1GglY","wrap":"File_wrap__Y+NqU","input":"File_input__56Qur","box":"File_box__HXIK4","remove":"File_remove__9pzr3"};